import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import { Button, TextArea } from "devextreme-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  askConfirmation,
  showResponseMessage,
  showSuccessMessage,
  showWarningMessage,
} from "../../../helper/message.js";
import { assetService } from "../../../apis/apiServices/Asset";
import { AssetSubStatus } from "../../../helper/fixcode";
import Modal from "react-modal";
import { Loader } from "../../Shared/PageLoader";

export default function ViewAssetMovementComponent(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    isApproved: false,
    isRecall: false,
    isSendBackToDraft: false,
    remark: "",
    isAddRemarkModalOpen: false,
    assetMovementRequestId: location?.state?.requestMovementId ?? 0,
    movementIndentNo: location?.state?.movementIndentNo ?? "",
    actionTypeId: 0,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    remarkValidation: "",
  });
  const [
    assetMovementRequestSubDataSourceLst,
    setAssetMovementRequestSubDataSourceLst,
  ] = useState([]);
  const [assetData, setAssetData] = useState(null);
  const { sourceUrl } = location.state || {};

  useLayoutEffect(() => {
    document.querySelector(
      "#pageTitle"
    ).innerHTML = `Asset Movement Request Preview`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      await Promise.all([
        getAssetMovementDetails(state.assetMovementRequestId),
        getAssetMovementRequestSub(state.assetMovementRequestId),
      ]);

      // await getAssetMovementDetails(state.assetMovementRequestId);
      // await getAssetMovementRequestSub(state.assetMovementRequestId);

      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetMovementDetails = async (requestId) => {
    try {
      let body = {
        requestMovementId: requestId,
        statusId: 0,
        userId: user?.userId,
      };
      const response = await assetService.getAssetMovementDetailsById(body);
      setAssetData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetMovementRequestSub = async (assetMovementRequestId) => {
    try {
      let body = {
        requestMovementId: assetMovementRequestId,
        statusId: 0,
      };
      const response = await assetService.assetMovementRequestListById(body);
      //console.log(response?.data?.assetMovementRequestSub);
      setAssetMovementRequestSubDataSourceLst(
        response?.data?.assetMovementRequestSub ?? []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const isValidRemarkData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.remarkValidation = "";
      if (!state.remark) {
        isValid = false;
        err.remarkValidation = "Please enter remark.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpdateAssetRequest = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure you want to approve this asset movement request?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isApproved: true }));
        let body = {
          assetMovementRequestId: assetData.requestMovementId,
          statusId: Number(AssetSubStatus.AssetMovementApproved),
          remark: state.remark,
          userId: user?.userId,
          isSentForApproval: false,
        };
        const response = await assetService.updateAssetMovementRequestStatus(
          body
        );

        if (response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showSuccessMessage(response?.message);
          setState((prev) => ({
            ...prev,
            isApproved: false,
            isAddRemarkModalOpen: false,
          }));

          if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else if (location.state.sourceUrl === "AssetMovement") {
            navigate("/AssetMovement");
          } else {
            navigate("/MyTasks");
          }
          return;
        }

        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isApproved: false }));
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location.state.sourceUrl === "MyTasks") {
              navigate("/MyTasks");
            } else if (location.state.sourceUrl === "AssetMovement") {
              navigate("/AssetMovement");
            } else {
              navigate("/MyTasks");
            }
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isApproved: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetRequest = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure you want to move this asset movement request back to draft?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSendBackToDraft: true }));
        const response = await assetService.sendAssetMovementRequestBackToDraft(
          assetData.requestMovementId,
          user?.userId,
          state.remark
        );
        if (!response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showWarningMessage(response?.message);
          setState((prev) => ({
            ...prev,
            isSendBackToDraft: false,
            isAddRemarkModalOpen: false,
          }));
          return;
        }
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSendBackToDraft: false }));
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location.state.sourceUrl === "MyTasks") {
              navigate("/MyTasks");
            } else {
              navigate("/AssetMovement");
            }
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSendBackToDraft: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetReCall = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure want to recall asset movement?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isRecall: true }));
        const response =
          await assetService.sendAssetMovementRequestBackToReCall(
            assetData.requestMovementId,
            user?.userId,
            state.remark
          );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isRecall: false }));
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location.state.sourceUrl === "MyTasks") {
              navigate("/MyTasks");
            } else {
              navigate("/AssetMovement");
            }
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isRecall: false }));
      console.log(error);
    }
  };

  const handleOnOpenAddRemarkModal = (actionTypeId) => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: true,
        actionTypeId: actionTypeId,
      }));
      let err = { ...errors };
      err.remarkValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAddRemarkModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: false,
        remark: "",
        isSendBackToDraft: false,
        isApproved: false,
        isRecall: false,
        actionTypeId: 0,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card top-bottom">
          {/* style={{ display: isPreviewOnly ? "none" : "" }} */}
          <div className="card-body">
            {!user?.isIframe && (
              <>
                <Button
                  text="Back"
                  icon="back"
                  onClick={() => {
                    if (sourceUrl === "AssetMovement") {
                      navigate("/AssetMovement");
                    } else if (sourceUrl === "ReportAssetMovement") {
                      navigate("/ReportAssetMovement");
                    } else if (sourceUrl === "UploadSAPAssetMovement") {
                      navigate("/PendingPRSAP");
                    } else if (sourceUrl === "ImportSAPAssetMovement") {
                      navigate("/ImportPR");
                    } else if (sourceUrl === "AcknowledgeAssetMovement") {
                      navigate("/assetAcknowledge");
                    } else if (sourceUrl === "MyTasks") {
                      navigate("/MyTasks");
                    }
                  }}
                  stylingMode="outlined"
                  type="default"
                  className="mr-2"
                  hint="Back"
                />
              </>
            )}

            {/* <button className='btn btn-primary btn-sm' title='Print' onClick={handlePrint}><i className="fas fa-print"></i> Print</button> */}
            {/* {assetData?.statusId === AssetSubStatus.AssetMovementSendforApproval &&
                            assetData?.toId === user?.userId && (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={async (e) => {
                                        await handleOnUpdateAssetRequest(e);
                                    }}
                                >
                                    <span title="Approve">
                                        <i
                                            className={`fas fa-${state.isApproved ? "spinner fa-spin" : "check"
                                                }`}
                                        />
                                        &nbsp;&nbsp;Approve
                                    </span>
                                </button>
                            )}
                        &nbsp;&nbsp; */}
            {!location?.state?.isReport && (
              <>
                {assetData?.isApproved === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      hidden={!props?.featurePermission?.canApprove}
                      onClick={() => {
                        handleOnOpenAddRemarkModal(1);
                      }}
                    >
                      <span title="Approve">
                        <i className="fas fa-check" />
                        &nbsp;&nbsp;Approve
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isSendBackToDraft === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(2);
                      }}
                    >
                      <span title="Back to Draft">
                        <i className="fas fa-arrow-left" />
                        &nbsp;&nbsp;Back to Draft
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isRollBack === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(3);
                      }}
                    >
                      <span title="Recall">
                        <i className="fas fa-undo" />
                        &nbsp;&nbsp;Recall
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
              </>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              hidden={!props?.featurePermission?.canPrint}
              onClick={async (e) => {
                window.print();
              }}
            >
              <span title="Print">
                <i className="fas fa-print" />
                &nbsp;&nbsp;Print
              </span>
            </button>
          </div>
        </div>
        <div className="row">
          {/* {isPreviewOnly && <div className='col-lg-2 col-md-3'></div>} */}
          {/* <div ref={contentRef}> */}
          <div className={"col-lg-9 col-md-6"}>
            <div className="card">
              <div className="card-body">
                <table width="100%" className="page-header">
                  <tr>
                    <td>
                      <div className="imglogo mt-2">
                        <img
                          src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png"
                          alt="DigilinkZ | Streamlining Storage, Access & Organization"
                          width="150"
                          className=""
                        />
                      </div>
                    </td>
                    <td align="right">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", color: "#282C7D" }}
                      >
                        Registered Office
                      </h6>
                      <p className="mb-0 pb-0 small">
                        8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                        Road No. 2, Banjara Hills, Hyderabad – 500034
                      </p>
                    </td>
                  </tr>
                </table>
                <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          ASSET MOVEMENT INDENT NO
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {assetData?.movementIndentNo}
                        </h6>
                      </td>
                      {/* <td width="50%" className='text-right'></td> */}
                    </tr>
                  </table>
                </div>
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    <tr>
                      <td width="150px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.fromName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.toName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>From Project</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.fromProjectName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Project</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.toProjectName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Asset Request No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.assetRequestNo}
                      </td>
                    </tr>
                    {/* <tr>
                                            <td style={{ fontSize: "0.9rem" }}>FR No.</td>
                                            <td
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "500",
                                                    color: "#282C7D",
                                                }}
                                            >
                                                {assetData?.movementIndentNo}
                                            </td>
                                        </tr> */}
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Movement Date</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.requestedDate
                          ? new Date(
                              assetData?.requestedDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : ""}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div className="message-body">
                  <table width={"100%"} className="asset-details">
                    <thead>
                      <tr>
                        <th>Asset Request No</th>
                        <th>Asset Description</th>
                        <th>Asset Id</th>
                        <th>Transport Details (Vehicle No, Movement Type)</th>
                        {/* <th>Vehicle No</th> */}
                        <th>Transport Charges</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assetMovementRequestSubDataSourceLst?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item?.assetRequestSubNo}</td>
                            <td>{item?.categoryName}</td>
                            <td>{item?.allocatedAssetSerialNo}</td>
                            {/* <td>{item?.transportVehicle}</td> */}
                            {/* <td>{item?.transportationId === 1 ? "T" : "P"}</td> */}
                            <td>
                              <center>
                                {item?.transportationId === 1 ? (
                                  <>
                                    <div>{item?.transportationName ?? ""}</div>
                                    <small style={{ fontSize: "12px" }}>
                                      {item?.transportVehicle ?? ""}
                                      &nbsp;&nbsp;[
                                      {item?.transportationName ?? ""}]
                                    </small>
                                  </>
                                ) : (
                                  <>
                                    <div>{item?.transportVendorName ?? ""}</div>
                                    <small style={{ fontSize: "12px" }}>
                                      {item?.transportVehicle ?? ""}
                                      &nbsp;&nbsp;[
                                      {item?.transportationName ?? ""}]
                                    </small>
                                  </>
                                )}
                              </center>
                            </td>
                            {/* <td>{item?.transportVehicle}</td> */}
                            <td>{item.transportCharges}</td>
                            <td>{item.remark}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="page-footer">www.vishwasamudra.in</div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div className="list-group">
                  {assetData?.history?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item.statusName === "Recall"
                          ? "Recall Requested"
                          : item.statusName}{" "}
                        by {item.fullName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>
                          {item.remarkDate ?? ""}
                          {/* {item.remarkDate
                            ? new Date(item.remarkDate).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }) +
                            ' ' +
                            new Date(item.remarkDate).toLocaleTimeString('en-GB', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            })
                            : ''} */}
                        </small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.remarks}
                      </div>
                      {/* <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>{item?.updatedOn}</small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.statusName}
                      </div> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetData?.assetMovementRequestAttachments?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetData?.assetMovementRequestAttachments?.map(
                    (item, index) => (
                      <div className="list-group">
                        <div
                          key={index}
                          className="list-group-item list-group-item-action flex-column align-items-start"
                          style={{
                            borderBottom: "1px solid #cfcfcf",
                            marginBottom: "0.5rem",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <div className="d-flex w-100 justify-content-between align-items-center">
                            <small
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                const fileUrl =
                                  process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                  item?.filePath;
                                window.open(item.fileUrl, "_blank");
                              }}
                            >
                              {item?.fileName}
                              {/* item?.fileType */}
                            </small>
                            <small>{item?.fileSize} kb</small>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>

      {/* For Adding Remark (Approve/Back To Draft/Recall) */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAddRemarkModalOpen}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Adding Remark (Approve/Back To Draft/Recall)"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.actionTypeId === 1
              ? "Send for Approval"
              : state.actionTypeId === 2
              ? "Back To Draft"
              : state.actionTypeId === 3
              ? "Recall"
              : ""}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  height={150}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Submit"
            onClick={async (e) => {
              if (state.actionTypeId === 1) {
                await handleOnUpdateAssetRequest(e);
              } else if (state.actionTypeId === 2) {
                await handleOnBackToDraftAssetRequest(e);
              } else if (state.actionTypeId === 3) {
                await handleOnBackToDraftAssetReCall(e);
              }
            }}
            disabled={
              state.actionTypeId === 1
                ? state.isApproved
                : state.actionTypeId === 2
                ? state.isSendBackToDraft
                : state.actionTypeId === 3
                ? state.isRecall
                : false
            }
          >
            <span title="Submit">
              {state.actionTypeId === 1 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isApproved ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 2 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isSendBackToDraft ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 3 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isRecall ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : null}
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
